import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunner,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
// Poolcorp Custom Code
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    getAlsoPurchasedProductsCollectionV2,
    GetRelatedProductCollectionApiV2Parameter,
    getRelatedProductsCollectionV2,
} from "@insite/client-framework/Services/ProductServiceV2";
import { 
    DispatchBeginLoadProducts,
    DispatchCompleteLoadProducts,
    ExecuteOnSuccessCallback,
    SortCollections,
    SortFacets
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { GetProductCollectionApiV2ParameterCustom, getProductCollectionV2 } from "@store/Services/ProductServiceV2"; // Poolcorp Custom Code

type Parameter = (
    | GetProductCollectionApiV2ParameterCustom // Poolcorp Custom Code
    | GetRelatedProductCollectionApiV2Parameter
    | GetAlsoPurchasedProductCollectionApiV2Parameter
) &
    HasOnSuccess<ProductModel[]> &
    HasOnError<string>;
type Props = {
    apiParameter:
        | GetProductCollectionApiV2ParameterCustom // Poolcorp Custom Code
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => { // Poolcorp Custom Code - HandlerType is a different type that simply adds properties to the other one.
    const { onSuccess, onError, ...parameter } = props.parameter;
    props.apiParameter = parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        if ("relationship" in props.apiParameter) {
            props.apiResult = await getRelatedProductsCollectionV2(props.apiParameter);
        } else if ("productId" in props.apiParameter && props.apiParameter?.type === "alsoPurchased") {
            props.apiResult = await getAlsoPurchasedProductsCollectionV2(props.apiParameter);
        } else {
            const parameter = {...props.apiParameter, onComplete: undefined}; // Poolcorp Custom Code
            props.apiResult = await getProductCollectionV2(parameter); // Poolcorp Custom Import
        }
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }

        throw error;
    }
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadProducts,
    RequestDataFromApi,
    SortFacets,
    SortCollections,
    DispatchCompleteLoadProducts,
    ExecuteOnSuccessCallback,
];

const loadProductsByProductNumbers = createHandlerChainRunner(chain, "LoadProductsByProductNumbers");
export default loadProductsByProductNumbers;
